var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRentcar = function SvgIconRentcar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 104,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__a)",
    fillOpacity: 0.8,
    d: "M60 71.714c33.137 0 60 1.343 60 3s-26.863 3-60 3-60-1.343-60-3 26.863-3 60-3",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24262C",
    d: "M34.146 69.65h-3.558c-.827 4.477-4.477 6.922-6.198 7.078 8.264.466 9.411-5.213 9.756-7.078M77.073 69.65H74.49c-.826 5.223-4.964 6.93-6.685 7.11 8.264.545 8.924-4.934 9.268-7.11M59.511 69.65h-2.295c-.735 4.477-3.98 5.907-5.51 6.062 7.346.466 7.5-4.197 7.805-6.062M104.388 68.634h-2.582c-.827 5.222-4.476 6.89-6.198 7.072 8.264.544 8.436-4.896 8.78-7.073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M103.413 68.634c0 3.922-3.894 7.11-7.366 7.11-3.473 0-6.293-3.177-6.293-7.11s2.82-7.111 6.293-7.111c3.472 0 7.366 3.177 7.366 7.11M57.56 69.142c0 3.642-2.623 6.603-5.853 6.603s-5.854-2.95-5.854-6.603 2.623-6.603 5.854-6.603 5.853 2.95 5.853 6.603"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__b)",
    d: "M105.182 54.886c-4.457-5.142-12.452-8.282-15.1-9.975C87.423 43.23 79.745 34 65.442 34c-4.55 0-16.113.255-24.823.255-6.175 0-10.92 1.076-14.59 2.545a29 29 0 0 0-5.98 3.225c3.895-1.426 8.904-2.597 14.528-2.448 11.706.298 18.985 7.058 18.985 7.058l4.959 7.068s8.485 1.458 15.162 5.12c4.447 2.438 5.582 9.527 5.868 12.998 15.714-.022 26.919-.213 27.707-.745 2.269-1.533.46-11.242-2.076-14.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__c)",
    fillOpacity: 0.2,
    d: "M105.182 54.886c-4.457-5.142-12.452-8.282-15.1-9.975C87.423 43.23 79.745 34 65.442 34c-4.55 0-16.113.255-24.823.255-6.175 0-10.92 1.076-14.59 2.545a29 29 0 0 0-5.98 3.225c3.895-1.426 8.904-2.597 14.528-2.448 11.706.298 18.985 7.058 18.985 7.058l4.959 7.068s8.485 1.458 15.162 5.12c4.447 2.438 5.582 9.527 5.868 12.998 15.714-.022 26.919-.213 27.707-.745 2.269-1.533.46-11.242-2.076-14.18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__d)",
    fillOpacity: 0.2,
    d: "M105.182 54.886c-4.457-5.142-12.452-8.282-15.1-9.975C87.423 43.23 79.745 34 65.442 34c-4.55 0-16.113.255-24.823.255-6.175 0-10.92 1.076-14.59 2.545a29 29 0 0 0-5.98 3.225c3.895-1.426 8.904-2.597 14.528-2.448 11.706.298 18.985 7.058 18.985 7.058l4.959 7.068s8.485 1.458 15.162 5.12c4.447 2.438 5.582 9.527 5.868 12.998 15.714-.022 26.919-.213 27.707-.745 2.269-1.533.46-11.242-2.076-14.18z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__e)",
    d: "M73.674 56.823c-6.677-3.662-15.162-5.12-15.162-5.12l-4.959-7.068s-7.28-6.76-18.986-7.058c-5.623-.139-10.632 1.022-14.528 2.448a32 32 0 0 0-2.842 2.236c-2.832 2.448-2.842 5.61-3.22 9.75-.113 1.182-.736 5.355-2.086 8.432-.5 1.139.123 3.821.665 5.12.777 1.841 2.903 3.822 4.641 3.822 13.27 0 40.517.457 62.345.425-.286-3.47-1.421-10.56-5.868-12.997z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__f)",
    fillOpacity: 0.3,
    d: "M73.674 56.823c-6.677-3.662-15.162-5.12-15.162-5.12l-4.959-7.068s-7.28-6.76-18.986-7.058c-5.623-.139-10.632 1.022-14.528 2.448a32 32 0 0 0-2.842 2.236c-2.832 2.448-2.842 5.61-3.22 9.75-.113 1.182-.736 5.355-2.086 8.432-.5 1.139.123 3.821.665 5.12.777 1.841 2.903 3.822 4.641 3.822 13.27 0 40.517.457 62.345.425-.286-3.47-1.421-10.56-5.868-12.997z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__g)",
    fillOpacity: 0.2,
    d: "M73.674 56.823c-6.677-3.662-15.162-5.12-15.162-5.12l-4.959-7.068s-7.28-6.76-18.986-7.058c-5.623-.139-10.632 1.022-14.528 2.448a32 32 0 0 0-2.842 2.236c-2.832 2.448-2.842 5.61-3.22 9.75-.113 1.182-.736 5.355-2.086 8.432-.5 1.139.123 3.821.665 5.12.777 1.841 2.903 3.822 4.641 3.822 13.27 0 40.517.457 62.345.425-.286-3.47-1.421-10.56-5.868-12.997z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__h)",
    d: "M11.707 62.22s0 3.684 1.421 5.44 1.707 2.534 4.407 2.534h87.444c1.85 0 3.2-1.661 3.251-3.439H15.265s-2.28-2.64-3.558-4.534"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__i)",
    d: "M31.685 69.896c0 3.811-2.873 6.909-6.41 6.909s-6.41-3.087-6.41-6.909 2.872-6.909 6.41-6.909c3.537 0 6.41 3.088 6.41 6.91"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__j)",
    d: "M25.274 74.387c2.383 0 4.314-2.012 4.314-4.493 0-2.48-1.931-4.492-4.314-4.492s-4.315 2.011-4.315 4.492 1.932 4.492 4.315 4.492"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__k)",
    stroke: "url(#icon-rentcar_svg__l)",
    strokeWidth: 0.103,
    d: "M24.19 69.896c0-.623.49-1.13 1.084-1.13.593 0 1.083.507 1.083 1.13s-.49 1.13-1.083 1.13c-.594 0-1.084-.507-1.084-1.13Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__m)",
    d: "M74.625 69.896c0 3.811-2.873 6.909-6.41 6.909s-6.41-3.087-6.41-6.909 2.873-6.909 6.41-6.909 6.41 3.088 6.41 6.91"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__n)",
    d: "M68.214 74.387c2.383 0 4.315-2.012 4.315-4.493 0-2.48-1.932-4.492-4.315-4.492-2.382 0-4.314 2.011-4.314 4.492s1.932 4.492 4.314 4.492"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__o)",
    stroke: "url(#icon-rentcar_svg__p)",
    strokeWidth: 0.103,
    d: "M67.13 69.896c0-.623.491-1.13 1.084-1.13s1.084.507 1.084 1.13-.49 1.13-1.084 1.13c-.593 0-1.083-.507-1.083-1.13Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__q)",
    d: "m14.407 47.072 3.322-3.14.89 2.171-4.642 5.908z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__r)",
    d: "M103.967 60.028h3.527s-.501-4.652-2.321-5.142c-1.104.98-1.216 5.142-1.216 5.142z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__s)",
    d: "M101.718 61.794H89.684c-.572 0-.817 0-1.094 1.054-.235.884-.848 3.566-.848 3.566-.051.67.45 1.246 1.094 1.246h13.925c.736 0 1.267-.745 1.053-1.49l-1.043-3.567a1.11 1.11 0 0 0-1.053-.809"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__t)",
    d: "M101.001 63.316h-9.856v2.544h9.856z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__u)",
    d: "M69.206 54.886s1.053 4.482 5.04 4.94c3.977.457 9.242 0 9.242 0s-.409-3.354-4.12-4.248-10.152-.692-10.152-.692z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__v)",
    fillOpacity: 0.2,
    d: "M69.206 54.886s1.053 4.482 5.04 4.94c3.977.457 9.242 0 9.242 0s-.409-3.354-4.12-4.248-10.152-.692-10.152-.692z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__w)",
    d: "M51.314 41.814a28 28 0 0 0-1.656-1.81c-2.822-2.704-6.288-3.726-17.667-2.086-5.807.84-9.927 5.141-9.927 5.141l.828 1.565 1.646 3.13 31.336.458s-1.135-2.396-4.55-6.398z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__x)",
    d: "M88.598 42.52c-3.067-2.13-6.134-4.259-9.201-5.323-8.721-.245-26.715.457-26.715.457l2.086 2.683 5.879 7.58 29.096-.246 5.866.14c-1.422-1.533-4.782-3.674-7.01-5.292"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__y)",
    fillOpacity: 0.2,
    d: "M88.598 42.52c-3.067-2.13-6.134-4.259-9.201-5.323-8.721-.245-26.715.457-26.715.457l2.086 2.683 5.879 7.58 29.096-.246 5.866.14c-1.422-1.533-4.782-3.674-7.01-5.292"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-rentcar_svg__z)",
    fillOpacity: 0.2,
    d: "M88.598 42.52c-3.067-2.13-6.134-4.259-9.201-5.323-8.721-.245-26.715.457-26.715.457l2.086 2.683 5.879 7.58 29.096-.246 5.866.14c-1.422-1.533-4.782-3.674-7.01-5.292"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__b",
    x1: 60.78,
    x2: 96.591,
    y1: 52.107,
    y2: 48.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F7F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F6F6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__c",
    x1: 103.72,
    x2: 92.088,
    y1: 65.946,
    y2: 56.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#C7C9CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E7EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__d",
    x1: 79.183,
    x2: 81.329,
    y1: 65.414,
    y2: 62.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9CAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F2F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__e",
    x1: 42.081,
    x2: 39.696,
    y1: 40.762,
    y2: 69.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676,
    stopColor: "#EDEDF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#C8C9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFAFBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__f",
    x1: 73.05,
    x2: 88.451,
    y1: 58.495,
    y2: 72.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E4EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__g",
    x1: 58.736,
    x2: 53.583,
    y1: 43.05,
    y2: 55.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__h",
    x1: 110.367,
    x2: 35.183,
    y1: 62.221,
    y2: 68.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E9EAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#F4F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#C4C5CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C7D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__i",
    x1: 25.275,
    x2: 25.275,
    y1: 62.987,
    y2: 76.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__j",
    x1: 25.274,
    x2: 25.274,
    y1: 65.402,
    y2: 74.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__k",
    x1: 25.274,
    x2: 25.274,
    y1: 71.078,
    y2: 68.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__l",
    x1: 25.274,
    x2: 25.274,
    y1: 71.078,
    y2: 68.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__m",
    x1: 68.215,
    x2: 68.215,
    y1: 62.987,
    y2: 76.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E4F5F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__n",
    x1: 68.214,
    x2: 68.214,
    y1: 65.402,
    y2: 74.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767788"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.684,
    stopColor: "#AAACBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__o",
    x1: 68.214,
    x2: 68.214,
    y1: 71.078,
    y2: 68.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7E93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAACBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__p",
    x1: 68.214,
    x2: 68.214,
    y1: 71.078,
    y2: 68.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__q",
    x1: 17.564,
    x2: 12.98,
    y1: 30.802,
    y2: 49.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__r",
    x1: 105.725,
    x2: 105.925,
    y1: 60.102,
    y2: 54.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABABB8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__s",
    x1: 95.8,
    x2: 95.8,
    y1: 61.794,
    y2: 67.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__t",
    x1: 96.073,
    x2: 96.073,
    y1: 63.316,
    y2: 65.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#DADADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__u",
    x1: 76.25,
    x2: 76.438,
    y1: 59.985,
    y2: 55.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D7D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9EA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__v",
    x1: 63.337,
    x2: 74.894,
    y1: 63.817,
    y2: 55.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.789
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__w",
    x1: 43.414,
    x2: 24.39,
    y1: 43.747,
    y2: 43.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515571"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__x",
    x1: 57.927,
    x2: 76.352,
    y1: 46.245,
    y2: 17.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#858698"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#A1A3B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#C0C3D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661,
    stopColor: "#C0C3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#BDBECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D8DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__y",
    x1: 83.998,
    x2: 78.64,
    y1: 37.729,
    y2: 43.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-rentcar_svg__z",
    x1: 73.296,
    x2: 71.186,
    y1: 48.259,
    y2: 36.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17181A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#747685",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "icon-rentcar_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(59.8114 0 0 2.99203 59.894 75.096)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#727272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgIconRentcar;